import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Pod24CommonLayout } from '../layouts/Pod24CommonLayout'

export const AuthFailedPage: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    // 실패 이유가 있다면 콘솔에 출력
    const error = searchParams.get('error')
    const errorDescription = searchParams.get('error_description')
    
    if (error) {
      console.error('OAuth 로그인 실패:', error)
      console.error('상세 내용:', errorDescription)
    }
  }, [searchParams])

  const handleRetry = () => {
    navigate('/')
  }

  const handleEmailLogin = () => {
    navigate('/') // 메인 페이지에서 로그인 모달 열기
  }

  return (
    <Pod24CommonLayout>
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="text-center max-w-md">
          <div className="mb-8">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">로그인 실패</h1>
            <p className="text-gray-600 mb-6">
              소셜 로그인 처리 중 문제가 발생했습니다.<br />
              다시 시도해보세요.
            </p>
          </div>

          <div className="space-y-3">
            <button
              onClick={handleRetry}
              className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              다시 시도하기
            </button>
            <button
              onClick={handleEmailLogin}
              className="w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-200 transition-colors font-medium"
            >
              이메일로 로그인하기
            </button>
          </div>

          <div className="mt-8 text-sm text-gray-500">
            <p>문제가 지속될 경우 고객센터로 문의해주세요.</p>
          </div>
        </div>
      </div>
    </Pod24CommonLayout>
  )
}